import * as React from "react";
import { IPaymentErrors, PaymentCard } from "./PaymentCard";
import amex from "../../../assets/images/payments/amexp.png";
import mastercard from "../../../assets/images/payments/mastercard.png";
import visa from "../../../assets/images/payments/visa.png";

export interface IPaymentDetailsProps {
  paymentErrors: IPaymentErrors;
  setPaymentErrors: React.Dispatch<React.SetStateAction<IPaymentErrors>>;
}

export function PaymentDetails(props: IPaymentDetailsProps) {
  return (
    <div className="payment-details">
      <div className="payment-details__header">
        <h2 className="sign-up-form__title">Credit / Debit Card</h2>
        <div className="card-cards">
          <div className="card-cards__cards">
            {[visa, mastercard, amex].map((item) => {
              return <img className="card-cards__item" src={item} alt="card" />;
            })}
          </div>
        </div>
      </div>
      <PaymentCard {...props} />
    </div>
  );
}
